import { Component, ElementRef, ViewChild, Input } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
  selector: "app-video",
  templateUrl: "./video.component.html",
  styleUrls: ["./video.component.scss"],
})
export class VideoComponent {
  public safeVideoUrl: SafeUrl;

  @Input("url") videoUrl: string;

  @ViewChild("videoIframe") iframeRef: ElementRef;
  @ViewChild("videoTag") videoRef: ElementRef;

  constructor(private readonly DomSanitizer: DomSanitizer) {}

  ngOnInit() {
    // Angular doesnt like it when you use unchecked urls for attributes like src.
    // So to make angular happy, we first sanitize the url with their pre built DomSanitizer.
    this.safeVideoUrl = this.DomSanitizer.bypassSecurityTrustResourceUrl(
      this.videoUrl
    );
  }

  public get isYoutubeVideo(): boolean {
    return this.videoUrl.includes("youtube");
  }

  /**
   * Removes the element containing the video. This is useful when you want to
   * force the media stream to stop, e.g. when a modal containing the video is closed.
   */
  public remove() {
    if (this.isYoutubeVideo)
      (this.iframeRef.nativeElement as HTMLIFrameElement).remove();
    else (this.videoRef.nativeElement as HTMLVideoElement).remove();
  }

  /**
   * Pauses the Video and enables to continue watching at the time pauseVideo had been called
   *  as long as Page doesn't refresh   --ISSUE with pausing iframes
   */
  public pauseVideo() {
    if (this.isYoutubeVideo) {
      let iframe = (this.iframeRef.nativeElement as HTMLIFrameElement)
        .contentWindow;
      let command = JSON.stringify({ event: "command", func: "pauseVideo" });
      iframe.postMessage(command, "*");
    } else {
      (this.videoRef.nativeElement as HTMLVideoElement).pause();
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/video/video.component.ts